export default class Newsletter {
    constructor() {
        document.querySelectorAll('[data-newsletter]').forEach((root) => {
            const form = root.querySelector('form')
            const button = form.querySelector('button[type="submit"]')
            const message = form.querySelector('[data-newsletter-message]')
            const label = button.innerHTML
            const it = root.dataset.lang === 'it'
            const api = ['localhost', '127.0.0.1'].includes(location.hostname) ? 'http://127.0.0.1:4545/api/newsletter-signups' : 'https://michelelaurelli.it/admin/api/newsletter-signups'
            const fail = (text) => { message.dataset.error = 'true'; message.textContent = text }
            form.addEventListener('submit', async (event) => {
                event.preventDefault()
                message.dataset.error = 'false'
                message.textContent = ''
                const email = form.email.value.trim()
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fail(it ? 'Controlla l’indirizzo email: sembra incompleto.' : 'Check the email address: it looks incomplete.'); form.email.focus(); return }
                if (!form.consent.checked) { fail(it ? 'Per iscriverti serve il consenso esplicito.' : 'Explicit consent is required to subscribe.'); return }
                button.disabled = true
                button.textContent = it ? 'Iscrivo…' : 'Subscribing…'
                try {
                    const response = await fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, consent: true, lang: root.dataset.lang, source: location.pathname, channel: 'sito', website: form.website.value }) })
                    const data = await response.json().catch(() => ({}))
                    if (!response.ok) throw new Error(data.error || (it ? 'Iscrizione non riuscita. Riprova.' : 'Subscription failed. Try again.'))
                    if (data.status === 'subscribed') message.textContent = it ? 'Sei già iscritto: le prossime uscite arrivano a questo indirizzo.' : 'You are already subscribed: the next issues will reach this address.'
                    else if (data.already) message.textContent = it ? 'L’iscrizione aspetta la tua conferma: cerca la mia email di conferma (da ciao@michelelaurelli.it), anche nello spam.' : 'Your subscription is waiting for confirmation: look for my confirmation email (from ciao@michelelaurelli.it), spam folder included.'
                    else message.textContent = it ? 'Quasi fatto: ti ho inviato una email, clicca il link per confermare.' : 'Almost there: I sent you an email, click the link to confirm.'
                    form.reset()
                } catch (error) {
                    fail(error instanceof TypeError ? (it ? 'Connessione non riuscita. Controlla la rete e riprova.' : 'Connection failed. Check your network and try again.') : error.message)
                } finally {
                    button.disabled = false
                    button.innerHTML = label
                }
            })
        })
    }
}
